import { registerPlugin } from '@capacitor/core';
import type { CapacitorPluginScePlugin } from './definitions';

const CapacitorPluginSceiOS = registerPlugin<CapacitorPluginScePlugin>('CapacitorPluginSceiOS');


export * from './definitions';
export { CapacitorPluginSceiOS };

